// Cinematic brand media (AI-generated, on-brand) + transparent logo
export const LOGO = "/abercal-logo.png";

export const MEDIA = {
  spark: "https://static.prod-images.emergentagent.com/jobs/aec451b0-d89e-455d-9857-7783e3befae8/images/ccf160c13306c5dafe03ec795e14b10d71c72c503c257c7b02f4ebca3517f08c.png",
  tangle: "https://static.prod-images.emergentagent.com/jobs/aec451b0-d89e-455d-9857-7783e3befae8/images/4a8fb50a941d8c550b7dc082190375c2d4aaa2e1c363d6e158992d09c679a86a.png",
  weave: "/weave-loom.png",
  forge: "https://static.prod-images.emergentagent.com/jobs/aec451b0-d89e-455d-9857-7783e3befae8/images/abf496cbb46baf2c8685c6177df16c4d50a2ae4100ae47d7927f2cd79401dc31.png",
};

// [replace me] owner: confirm contact email
export const CONTACT_EMAIL = "hello@abercal.ca";
export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/abercallabs/" },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61592513410658" },
];
